import React from "react";
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import About from '../../components/About';

const AboutPage = () => {
  return (
    <div>
      <LogoutHeader />
      <main>
        <About />
      </main>
      <LogoutFooter />
    </div>
  );
};

export default AboutPage;